<template>
	<div class="add-tab-page">
		<TabForm />
	</div>
</template>

<script>
	import TabForm from '@/components/TabForm';

	export default {
		components: {
			TabForm
		}
	};
</script>
